<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LH8w2e/tc-custom/9781467465687.jpg?1730410162207" alt="This image is the cover for the book Thirty Years That Changed the World, The Eerdmans Michael Green Collection (EMGC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thirty Years That Changed the World, The Eerdmans Michael Green Collection (EMGC)
      </h1>
      <p class="bookDescription body article font2">
        <b>The first Christians turned the world upside down in the space of a generation. How can we learn from them today?  </b><br/>  <br/> In this book Michael Green opens up the gripping story of Acts, highlighting the volcanic eruption of faith described there and contrasting it with the often halfhearted Christianity of the modern Western world. Green explores the life and faith of the Christians of Acts, answering such questions as, What kind of people were they? How did they live? And how did they organize and practice as members of the new church? Besides describing life in the early church, Green discusses how we today can apply the first Christians’ dynamic efforts at church planting, pastoral care, social concern, gospel proclamation, and prayer. Combining trusted scholarship with a popular, enjoyable writing style, <i>Thirty Years That Changed the World</i> is an ideal book for church, group, or personal study.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Green
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Michael Green</B>&#160;(1930&ndash;2019) was one of the best-known British evangelical theologians and preachers of his generation. A scholar with degrees from the universities of Oxford, Cambridge, and Toronto, Green had a passion for evangelism and a rare talent for communicating complex ideas in easy-to-understand language. In 1996, Archbishop of Canterbury George Carey granted Green a Lambeth degree of Doctor of Divinity. ?He led university missions on six continents, pastored St. Aldate&#39;s Church Oxford, and introduced innovative approaches in seminary education. He authored more than seventy books across a range of fields, including evangelism, apologetics, biblical commentary, and academic theology.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ee1af096